// documentGuid values for the static help/guide PDFs, served via the MarketSecurity
// /documents/{documentGuid}/okta endpoint instead of being bundled as static assets.
// Each value is environment-specific and is tokenized per env in the vars/ folder.
export var helpDocGuid = {
    guideToAlternativeMarket: import.meta.env.VITE_HELPDOC_GUID_ALTERNATIVE_MARKET,
    marketSecurityGuide: import.meta.env.VITE_HELPDOC_GUID_MARKET_SECURITY_GUIDE,
    marketReviewUserGuide: import.meta.env.VITE_HELPDOC_GUID_MARKETREVIEW_USER_GUIDE,
    subRegions: import.meta.env.VITE_HELPDOC_GUID_SUBREGIONS,
    certifiedAuthorizedReinsurers: import.meta.env.VITE_HELPDOC_GUID_CERTIFIED_AUTHORIZED_REINSURERS,
    marketGroupProfile: import.meta.env.VITE_HELPDOC_GUID_MARKET_GROUP_PROFILE,
    marketPreView: import.meta.env.VITE_HELPDOC_GUID_MARKET_PREVIEW,
    marketReView: import.meta.env.VITE_HELPDOC_GUID_MARKET_REVIEW,
    ratingNotificationService: import.meta.env.VITE_HELPDOC_GUID_RATING_NOTIFICATION_SERVICE,
    ratingAndRatingAgencies: import.meta.env.VITE_HELPDOC_GUID_RATING_AND_RATING_AGENCIES,
    reportingRecoverables: import.meta.env.VITE_HELPDOC_GUID_REPORTING_RECOVERABLES,
    usTreasuryAcceptableSureties: import.meta.env.VITE_HELPDOC_GUID_US_TREASURY_ACCEPTABLE_SURETIES,
    factSheetGuide: import.meta.env.VITE_HELPDOC_GUID_FACT_SHEET_GUIDE,
};
